var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSistemiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4769",
    "data-name": "Group 4769",
    transform: "translate(-708 146)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "laptop_black_24dp",
    d: "M20,18a2.006,2.006,0,0,0,2-2V6a2.006,2.006,0,0,0-2-2H4A2.006,2.006,0,0,0,2,6V16a2.006,2.006,0,0,0,2,2H1a1,1,0,0,0,0,2H23a1,1,0,0,0,0-2ZM5,6H19a1,1,0,0,1,1,1v8a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V7A1,1,0,0,1,5,6Z",
    transform: "translate(708 -150)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4768",
    "data-name": "Group 4768",
    transform: "translate(5.638 -29.658)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4767",
    "data-name": "Group 4767",
    transform: "translate(710.127 -113.272)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7621",
    "data-name": "Path 7621",
    d: "M8.811,4.938,8.547,4.35l-.588-.265a.21.21,0,0,1,0-.382l.588-.265.265-.588a.21.21,0,0,1,.382,0l.265.588.588.265a.21.21,0,0,1,0,.382l-.588.265-.265.588A.21.21,0,0,1,8.811,4.938Zm1.361,1.987-.134-.3a.21.21,0,0,0-.382,0l-.134.3-.307.134a.21.21,0,0,0,0,.382l.3.134.134.307a.21.21,0,0,0,.382,0l.134-.3.307-.134a.21.21,0,0,0,0-.382Zm-2.117.693.517.391a.423.423,0,0,1,.109.546L8,9.731a.415.415,0,0,1-.525.176l-.6-.252a2.8,2.8,0,0,1-.269.155l-.08.647a.421.421,0,0,1-.416.37H4.754a.421.421,0,0,1-.416-.37l-.08-.647a2.473,2.473,0,0,1-.269-.155l-.6.252a.415.415,0,0,1-.525-.176L2.183,8.555a.423.423,0,0,1,.109-.546l.517-.391V7.463c0-.05,0-.105,0-.155L2.3,6.917a.423.423,0,0,1-.109-.546l.681-1.176a.415.415,0,0,1,.525-.176l.6.252a2.8,2.8,0,0,1,.269-.155l.08-.647A.414.414,0,0,1,4.754,4.1H6.11a.421.421,0,0,1,.416.37l.08.647a2.473,2.473,0,0,1,.269.155l.6-.252A.415.415,0,0,1,8,5.2l.681,1.176a.423.423,0,0,1-.109.546l-.517.391c0,.05,0,.1,0,.155S8.059,7.568,8.055,7.618ZM6.694,7.463a1.26,1.26,0,1,0-1.26,1.26A1.259,1.259,0,0,0,6.694,7.463Z",
    transform: "translate(-2.127 -2.727)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSistemiIcon);
export default __webpack_public_path__ + "static/media/sistemi_icon.d685eac96c9ed60ae6ec2f821f6ad8dd.svg";
export { ForwardRef as ReactComponent };